<div
  class="d-flex flex-column justify-content-center align-items-center vh-100 w-100 position-relative"
>
  <button
    class="btn-back position-absolute top-0 start-0 m-3 d-flex align-items-center gap-2"
    (click)="goToDashboard()"
  >
    <i class="bi bi-arrow-left"></i>
    Back to Dashboard
  </button>

  <div class="text-center">
    <ng-lottie
      [options]="options"
      [styles]="{ width: '800px', height: '800px' }"
    >
    </ng-lottie>
  </div>
</div>
